import { Check, X } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { t } from "@/i18n";

export const JOB_STEPS = ["received", "inspecting", "awaiting_approval", "approved", "in_progress", "ready", "completed"];

export function JobTracker({ status, testId = "job-tracker" }) {
  if (status === "cancelled") return <p className="inline-flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-sm font-semibold text-red-800" data-testid={testId}><X className="h-4 w-4" /> {t("status.cancelled")}</p>;
  const idx = JOB_STEPS.indexOf(status);
  return (
    <ol className="grid grid-cols-7 gap-1" data-testid={testId}>
      {JOB_STEPS.map((s, i) => {
        const done = i < idx || status === "completed";
        const cur = i === idx && status !== "completed";
        return (
          <li key={s} className="min-w-0" data-testid={`${testId}-step-${s}`}>
            <div className={`h-1.5 rounded-full ${done ? "bg-emerald-500" : cur ? "bg-[var(--brand,#0D9488)]" : "bg-slate-200"}`} />
            <p className={`mt-2 flex items-center gap-1 truncate text-[11px] font-semibold ${cur ? "text-slate-900" : done ? "text-emerald-700" : "text-slate-400"}`}>
              {done && <Check className="h-3 w-3 shrink-0" />}<span className="truncate">{t(`status.${s}`)}</span>
            </p>
          </li>
        );
      })}
    </ol>
  );
}

export function PhotoGrid({ photos, render, testId = "photo-grid" }) {
  if (!photos.length) return <p className="text-sm text-slate-500">{t("jobs.noPhotos")}</p>;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-testid={testId}>
      {photos.map((p) => (
        <figure key={p.id} className="overflow-hidden rounded-lg border border-slate-200 bg-white" data-testid={`photo-${p.id}`}>
          <a href={fileUrl(p.url)} target="_blank" rel="noreferrer"><img src={fileUrl(p.url)} alt={p.caption || ""} className="aspect-[4/3] w-full object-cover" /></a>
          <figcaption className="space-y-1 p-2 text-xs">
            <span className="font-semibold uppercase tracking-wider text-slate-500">{t(`status.${p.phase}`)}</span>
            {render ? render(p) : p.caption && <p className="text-slate-700">{p.caption}</p>}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
